import ApplicationController from './application'
export default class extends ApplicationController {

  static targets = ['content', 'contentTwo', 'inputOne', 'inputTwo', 'inputThree']
  static classes = ['toggle']

  connect() {
    if (!this.hasInputOneTarget || !this.hasInputTwoTarget || !this.hasInputThreeTarget) return
    const inputOne = this.inputOneTarget
    const inputTwo = this.inputTwoTarget
    const inputThree = this.inputThreeTarget
    const inputAction = 'keyup->content-visibility#update change->content-visibility#update paste->content-visibility#handlePaste'

    inputOne.setAttribute('data-action', `${inputOne.getAttribute('data-action') || ''} ${inputAction}`)
    inputTwo.setAttribute('data-action', `${inputTwo.getAttribute('data-action') || ''} ${inputAction}`)
    inputThree.setAttribute('data-action', `${inputThree.getAttribute('data-action') || ''} ${inputAction}`)
  }

  toggle(event) {
    const element = event.currentTarget
    const value = element.value
    const show = value === element.dataset.show
    const hide = (value === element.dataset.hide || value !== element.dataset.show)

    this.#contentToggle(show, hide)
  }

  update() {
    this.#validateInput()
  }

  handlePaste(event) {
    const pastedData = event.clipboardData.getData('text')
    const currentTargetId = event.currentTarget.getAttribute('id')

    setTimeout(() => {
      document.querySelector(`#${currentTargetId}`).value = pastedData
      this.#validateInput()
    }, 500)
  }

  includes(event) {
    const element = event.currentTarget
    const value = element.value
    const show = value.toLowerCase().includes(element.dataset.show)

    this.#contentToggle(show, !show)
  }

  #validateInput() {
    const inputOne = this.inputOneTarget
    const inputTwo = this.inputTwoTarget
    const inputThree = this.inputThreeTarget
    const pattern = inputTwo.getAttribute('pattern')
    const patternValid = pattern ? inputTwo.value.match(inputTwo.getAttribute('pattern')) : true
    const isValid = inputOne.value !== '' &&
      (inputTwo.value !== '' && patternValid) &&
      inputThree.value !== '' &&
      inputTwo.value == inputThree.value

    this.#contentToggle(!isValid, isValid)
  }

  #contentToggle(show, hide) {
    this.contentTargets.forEach(content => {
      if (show) {
        content.classList.remove(this.toggleClass)
      } else if (hide) {
        content.classList.add(this.toggleClass)
      }
    })

    this.contentTwoTargets.forEach(content => {
      if (show) {
        content.classList.add(this.toggleClass)
      } else if (hide) {
        content.classList.remove(this.toggleClass)
      }
    })
  }

}
